export default function DayCardSkeleton() {
  return (
    <div aria-hidden className="rounded-xl bg-surface-container-high p-4">
      <div className="h-4 w-[180px] animate-pulse rounded bg-on-surface/10" />
      <div className="mt-3 h-3 w-[260px] animate-pulse rounded bg-on-surface/10" />
    </div>
  );
}
